import {CommonOptionVM} from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"

export class HiddenPageOptionsVM extends CommonOptionVM {
  not_visible: boolean

  constructor(data: Partial< HiddenPageOptionsVM> = {}) {
    super(data)
    this.not_visible = true
  }

  validateData() {
    const errors: any[] = []
    if (this.not_visible !== true) {
      errors.push({ key: 'not_visible', error_message: 'not_visible must be true' })
    }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default  HiddenPageOptionsVM
